import * as styles from "./SliderIndicator.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Slider as BaseSlider } from "@base-ui/react/slider";

import type { SliderIndicatorProps } from "./Slider.types";

export function SliderIndicator({
  className,
  ...props
}: SliderIndicatorProps): JSX.Element {
  return (
    <BaseSlider.Indicator
      data-slot="slider-indicator"
      className={clsx(styles.indicator, className)}
      {...props}
    />
  );
}
